import React,{useEffect} from 'react'
import { useLocation } from 'react-router-dom'
import banner from '../../assets/images/our expertise banner.png'
import industry1 from '../../assets/images/Expertise1.png'
import industry2 from '../../assets/images/Expertise2.png'
import industry3 from '../../assets/images/Expertise3.png'
import aos from 'aos';
import 'aos/dist/aos.css'

const Our_Expertise = () => {
  const { top } = useLocation();
  useEffect(() => {
    aos.init({ duration: 1000 });
    window.scrollTo(0,0);
  }, [top]);
  return (
    <>
    <div className="container-fluid gx-0">
      <div className="row gx-0">
        <img className='img-fluid' data-aos="zoom-in" src={banner} alt="" />
      </div>
    </div>
      <div className="container py-lg-5">

        <div className="row py-lg-5 py-3">
          <p className="top-content" data-aos="zoom-in">Our team possesses extensive experience and knowledge in the pharmaceutical industry, dedicated to meeting your business needs. Our expertise encompasses</p>
        </div>

        <div className="row py-lg-5 py-3">
          <div className="col-lg-6 col-md-6">
            <img className='img-fluid' data-aos="zoom-in" src={industry1} alt="" />
          </div>
          <div className="col-lg-6 col-md-6 d-flex align-items-center">
            <div className="content industry-content" data-aos="zoom-in">
              <h4><label></label> Pharmaceutical Marketing Strategies with Best Manufacturing Practices <label></label></h4>
              <p>Marketing strategies for various formulations (tablets, capsules, injections, etc.)</p>
              <p>Therapeutic area expertise (neuropsychiatry, diabetes, cardiovascular, oncology, etc.)</p>
              <p>Brand development and management</p>
              <p>Distributor network and supply chain management</p>

            </div>
          </div>

        </div>

        <div className="row py-lg-5 py-3 change-column-direction">
        <div className="col-lg-6 col-md-6 d-flex align-items-center">
          <div className="content industry-content" data-aos="zoom-in">
            <h4><label></label> Medical and Scientific Expertise <label></label></h4>
            <p>Medical and scientific content development</p>
            <p>Clinical research and trial support</p>
            <p>Regulatory affairs expertise</p>
          </div>
        </div>
        <div className="col-lg-6 col-md-6">
          <img className='img-fluid' data-aos="zoom-in" src={industry2} alt="" />
        </div>
      </div>

      <div className="row py-lg-5 py-3">
          <div className="col-lg-6 col-md-6">
            <img className='img-fluid' data-aos="zoom-in" src={industry3} alt="" />
          </div>
          <div className="col-lg-6 col-md-6 d-flex align-items-center">
            <div className="content industry-content" data-aos="zoom-in">
              <h4><label></label>Business Strategies and Solutions<label></label></h4>
              <p>Market analysis and competitive studies</p>
              <p>Business development and strategic planning</p>
              <p>Training and capacity building</p>

            </div>
          </div>

        </div>

        <div className="row">
          <div className="col-12">
            <p className="top-content" data-aos="zoom-in">Our team is committed to helping your pharmaceutical business thrive. Partner with us to elevate your business to new heights.</p>
          </div>
        </div>


      </div>




    </>
  )
}

export default Our_Expertise
